import React, { Component } from 'react';

class ItemImage extends Component {
  render() {
    const {slide} = this.props;
    return (
      <div className="ItemImage" style={{backgroundImage: `url(${slide.src})`}} />
    );
  }
}

export default ItemImage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/components/Slide/components/ItemImage/index.jsx